import { render, staticRenderFns } from "./BidHistoryLotCard.vue?vue&type=template&id=13cd0c44"
import script from "./BidHistoryLotCard.vue?vue&type=script&lang=js"
export * from "./BidHistoryLotCard.vue?vue&type=script&lang=js"
import style0 from "./BidHistoryLotCard.vue?vue&type=style&index=0&id=13cd0c44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports